"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllPrototypeMethodNames = void 0;
const get_all_method_names_1 = require("./get-all-method-names");
const getAllPrototypeMethodNames = (obj) => (0, get_all_method_names_1.getAllMethodNames)(Object.getPrototypeOf(obj)).filter((property) => property !== "constructor");
exports.getAllPrototypeMethodNames = getAllPrototypeMethodNames;
